module.exports = __webpack_public_path__ + "images/img-DCyYJiR.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/preview.jpg
// module id = 2006
// module chunks = 0